import { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import queryString from 'query-string';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import LoginLayout from '../ui/Layout/LoginLayout';
import LoginCard from '../ui/LoginCard';
import { putUserSubscriptionWeb } from '../api/User';
import tdasLogo2 from '../assets/images/tdas-logo-2.png';
import errorDisc from '../assets/svg/disc/error-disc.svg';
import checkDisc from '../assets/svg/disc/check-disc.svg';

const LogoImg = styled.img`
  width: 100%;
`;

const DiscImg = styled.img`
  padding-bottom: 25px;
`;

const PrimaryButton = styled(Button)`
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 0;
`;

const OptInContainer = () => {
  const [error, setError] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const asyncUseEffect = async () => {
    const params = queryString.parse(window.location.search);
    if (!params?.email || !params?.utm_campaign) {
      setError('Missing email or campaign id');
    } else {
      const subscription = await putUserSubscriptionWeb(
        params.email,
        params.utm_campaign,
        true,
      );
      if (!subscription.ok) {
        setError(subscription.json);
      } else {
        setSubscribed(true);
      }
    }
  };
  useEffect(() => asyncUseEffect(), []);
  return (
    <LoginLayout>
      <LoginCard>
        <Card.Title as="h1">
          <LogoImg src={tdasLogo2} alt="Turn Down and Save" />
        </Card.Title>
        <Card.Body>
          {error ? (
            <>
              <DiscImg src={errorDisc} />
              <h2>Something Went Wrong</h2>
              <div>
                There was a problem with the opt-in request: <i>{error}</i>
              </div>
              <PrimaryButton
                variant="primary"
                onClick={() => {
                  window.location.href =
                    'https://kb.loop.homes/' +
                    'opting-in-to-turn-down-and-save-didnt-work-what-should-i-do-next';
                }}>
                Learn More
              </PrimaryButton>
            </>
          ) : (
            <>
              {!subscribed ? (
                <>
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </>
              ) : (
                <>
                  <DiscImg src={checkDisc} />
                  <h2>You&apos;re Signed Up</h2>
                  <div>
                    By taking part in Turn Down and Save you&apos;re helping to
                    make the grid greener and cheaper.
                  </div>
                </>
              )}
            </>
          )}
        </Card.Body>
      </LoginCard>
    </LoginLayout>
  );
};

export default OptInContainer;
